export default "__VITE_ASSET__abd1626b__"